import { uniqBy, memoize } from 'lodash';

export default memoize(function (countries = [], skipCodes) {
  const uniqueCountries = uniqBy(countries, 'code');
  return uniqueCountries
    .map((country) => ({
      label: `${country.code} - ${country.shortName}`,
      value: country.code,
    }))
    .filter((country) => !skipCodes.includes(country.value))
    .sort((a, b) => a.value - b.value);
});
